import {
  ActionBar,
  ChakraBox,
  ChakraFlex,
  FAIconName,
  Text,
} from '@equip.health/ui';

const ID_PREFIX = 'patient-note-care-plan-section';
export const PatientNoteCarePlanSectionErrorFallback = () => {
  return (
    <ChakraFlex
      display="unset"
      id={`${ID_PREFIX}-error-fallback`}
      margin="18px"
      padding="18px"
      width="100%"
    >
      <Text marginBottom="12px" variant="h4">
        Care plan
      </Text>
      <ChakraBox alignItems="center" width="100%">
        <ActionBar
          barIcon={FAIconName.exclamationTriangleRegular}
          id={`${ID_PREFIX}-error-action-bar`}
          text="Unable to load the care plan. Please reload the note or try again later."
          variant="critical"
        />
      </ChakraBox>
    </ChakraFlex>
  );
};
